"use client";

import React from "react";

import { ProductTileTrackingWrapperProps } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileTrackingWrapper/ProductTileTrackingWrapperProps";
import { useProductTileViewImpression } from "@faire/retailer/hooks/ProductTileImpression/useProductTileViewImpression";

import { useGetProductTileClickImpressions } from "../../productTileActions/useGetProductTileClickImpressions";

export const ProductTileTrackingWrapper = ({
  data: {
    productToken,
    isPromoted,
    impressionId,
    promotedBy,
    badgeList,
    bestImage,
    images,
    settingsToAssignOnView,
    recordProductTileImpressionForAds = false,
  },
  children,
}: {
  data: ProductTileTrackingWrapperProps;
  children: React.ReactNode;
}) => {
  const trackProductTileProps = useProductTileViewImpression({
    productToken,
    promotedBy,
    impressionId,
    turnOffTracking: recordProductTileImpressionForAds,
    settingsToAssignOnView,
  });
  const { recordProductTileRightClickEvent } =
    useGetProductTileClickImpressions({
      token: productToken,
      isPromoted,
      impressionId,
      promotedBy,
      badgeList,
      bestImage,
      images,
    });

  return (
    <div
      {...trackProductTileProps}
      onContextMenu={recordProductTileRightClickEvent}
      ref={(element) => {
        trackProductTileProps?.ref?.(element);
      }}
    >
      {children}
    </div>
  );
};
